import { Box } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';

const SavingPleaseWaitDialog = ({ reason = 'saving' }: { reason?: 'saving' | 'loading' }) => {
  const lang = useLanguage()[0].SavingPleaseWaitDialog;

  return (
    <Dialog
      title={lang.title[reason]}
      body={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <HourglassEmptyIcon sx={{ width: '2em', height: '2em' }} />
          <Box sx={{ mt: '16px' }}>{lang.pleaseWait}</Box>
        </Box>
      }
      sx={{
        '& .MuiPaper-root': {
          width: '170px',
          height: '170px',
          alignItems: 'center',
        },
      }}
      open
    />
  );
};

export default SavingPleaseWaitDialog;
